// @ts-check
// Código de acesso que chega pelo link do painel de suporte (contrato 08 de cobrança e operação, seção 7.1). O link
// usa #code= (o fragmento não vai ao servidor, aos logs nem ao Referer); ?code= também vale. Depois de ler, a tela
// troca o endereço pelo limpo, para o código não ficar no histórico nem ser copiado junto com a URL.
import { formatSignUpAccessCode, isWellFormedSignUpAccessCode } from '../../../shared/sign-up/sign-up-access-code.js';
import { formatDate, todayIsoDate } from './format.js';
import { t } from '../i18n/index.js';

const CODE_PARAMETER = 'code';

/**
 * @param {{ pathname: string, search: string, hash: string }} location
 * @returns {{ code: string | null, cleanUrl: string }} code null quando o endereço não traz código
 */
export function readSignUpCodeFromLocation(location) {
  const hashParameters = new URLSearchParams(location.hash.replace(/^#/, ''));
  const searchParameters = new URLSearchParams(location.search);
  const rawCode = (hashParameters.get(CODE_PARAMETER) ?? searchParameters.get(CODE_PARAMETER) ?? '').trim();
  hashParameters.delete(CODE_PARAMETER);
  searchParameters.delete(CODE_PARAMETER);
  const search = searchParameters.toString();
  const hash = hashParameters.toString();
  return {
    // o código do painel vem formatado XXXX-XXXX-XXXX-XXXX; o global (reserva) segue como foi escrito
    code: rawCode ? (isWellFormedSignUpAccessCode(rawCode) ? formatSignUpAccessCode(rawCode) : rawCode) : null,
    cleanUrl: `${location.pathname}${search ? `?${search}` : ''}${hash ? `#${hash}` : ''}`,
  };
}

/**
 * Final do código para a tela mostrar sem repetir o código inteiro.
 * @param {string} code
 */
export function signUpCodeEnding(code) {
  const compact = code.replace(/[\s-]/g, '');
  return compact.slice(-4).toUpperCase();
}

/** Data local (fuso da preferência, Brasília por padrão) de um instante. @param {string} instant */
export const formatLocalDate = (instant) => formatDate(todayIsoDate(new Date(instant)));

/**
 * Mensagem pronta do painel de suporte para WhatsApp ou e-mail: o link já leva o código, e o código vai escrito para
 * quem abrir o endereço sem o link.
 * @param {{ signUpUrl: string, code: string, expiresAt: string, allowedEmail?: string | null }} input
 */
export function buildSignUpShareMessage({ signUpUrl, code, expiresAt, allowedEmail }) {
  return [
    t('operations.admin.signUpCodes.shareMessage', { link: signUpUrl, date: formatLocalDate(expiresAt) }),
    allowedEmail ? t('operations.admin.signUpCodes.shareMessageEmail', { email: allowedEmail }) : null,
    t('operations.admin.signUpCodes.shareMessageCode', { code }),
  ].filter(Boolean).join(' ');
}
